var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.overlayActive)?_c('loader',{attrs:{"object":"#ff9633","color1":"#ffffff","color2":"#17fd3d","size":"5","speed":"2","bg":"#4F46E5","objectbg":"#999793","opacity":"80","name":"circular"}}):_vm._e(),_c('div',{attrs:{"id":"app","data-bs-spy":"scroll","data-bs-target":"#navbarScroll","data-bs-offset":"0"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }